<!-- 客服团队 -->
<template>
    <div id="team" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>客服监控</el-breadcrumb-item>
                <el-breadcrumb-item>客服团队</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">时间:</div>
            <el-date-picker
                    :picker-options="startDateOps"
                    class="search-item"
                    v-model="searchData.StartDate"
                    :clearable="boolFalse"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <span class="search-name">至</span>
            <el-date-picker
                    :clearable="boolFalse"
                    :picker-options="endDateOps"
                    class="search-item"
                    v-model="searchData.EndDate"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <div class="search-name">客服组:</div>
            <div class="search-item goods-categories">
                <el-input
                        size="small"
                        readonly
                        v-model="groupName"
                        @click.stop.native="showCategories()"
                        placeholder="请输选择客服组">
                </el-input>
                <div class="categories-tree" v-show="categoriesShow">
                    <serviceGroup @chooseNode="chooseNode"></serviceGroup>
                </div>
            </div>
            <div class="search-name">客服人员:</div>
            <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.sId"
                    placeholder="请选择">
                <el-option
                        v-for="item in services"
                        :label="item.Name"
                        :value="item.Id">
                </el-option>
            </el-select>
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
        </div>
        <div class="table-ctn">
            <el-table
                    :header-cell-style="{background:'#F2F6FC'}"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="date"
                        show-overflow-tooltip
                        label="日期">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="sName"
                        label="客服人员">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="state"
                        label="现时状态">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="receivedNUm"
                        label="已接待访客数">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="receivingNum"
                        label="正在接待访客数">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="duration"
                        label="沟通总时长">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="address"
                        label="对话情况">
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import serviceGroup from '@/components/common/serviceGroup.vue'
    export default {
        name: 'team',
        components: {
            serviceGroup
        },
        data() {
            return {
                boolFalse:false,
                startDateOps: {
                    disabledDate: (time) => {
                        return  time.getTime() > new Date().getTime();
                    }
                },
                endDateOps: {
                    disabledDate: (time) => {
                            return  time.getTime() > new Date().getTime();
                    }
                },
                groupName:'',
                services:[],
                categoriesShow:false,
                searchData: {
                    sId:'',
                    StartDate:'',
                    EndDate:'',
                    CascadeId:'',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                    key:'', //关键字查询
                },
                tableData: [],
                tableDataLength:0,

            }
        },
        mounted() {
            this.getTableData()
            let today = this.$util.getNowFormatDate()
            this.searchData.StartDate = today
            this.searchData.EndDate = today
            window.onclick = ()=>{
                this.categoriesShow = false
            }
        },
        methods: {
            showCategories(){
                this.categoriesShow = true
            },
            // 选中客服组分类
            chooseNode(data){
                if (data){
                    this.searchData.CascadeId = data.Item.CascadeId
                    this.groupName = data.Item.Name
                    this.getServicesByGId(data.Item.Id)
                }
                else {
                    this.searchData.CascadeId = ''
                    this.groupName = ''
                }
                this.categoriesShow = false
            },
            // 加载客服团队列表
            getTableData(){
                this.axios.get('/CSRManagement/LoadServiceTeam',{
                    params: this.searchData

                })
                    .then((response)=> {
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            //  根据客服组ID获取所有在职客服
            getServicesByGId(gId){
               this.$util.GetServicesByGId(gId).then(value => {
                   this.services = value
                   this.searchData.sId = ''
               })
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                let today = this.$util.getNowFormatDate()
                this.searchData = {
                    sId:'',
                    StartDate:today,
                    EndDate:today,
                    CascadeId:'',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                    key:'', //关键字查询
                }
                this.groupName =''
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>

</style>
